export default String.raw`
{% if hideContent -%}
{% else -%}
<div class="popup-dialog message-popup-background image-rotate-popup hidden-js">
    <input class="reset360" type="hidden">
    <div class="form-container imageContainerPopup">
        <span class="close-button close360-js">
            <svg width="24" height="24">
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
            </svg>
        </span>
        <div class="imageContainer360 img360" id="imageContainer360">
            <div class="imageContainer--360btns">
                <div class="imageContainer--360btn btn-left">
                    <svg width="12.5" height="20">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-left-{{settings.iconStyle}}"></use>
                    </svg>
                </div>
                <div class="imageContainer--360btn btn-auto">
                    <svg width="24" height="24">
                        <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#360'></use>
                    </svg>
                </div>
                <div class="imageContainer--360btn btn-right">
                    <svg width="12.5" height="20">
                        <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</div>
{% endif -%}
`